// extracted by mini-css-extract-plugin
export default {"plainText":"ChatTips_plainText__glkre","linkText":"ChatTips_linkText__gwaFF"};